import React from "react";
import PackageGroupSelection from "../../components/PackagesSection/PackageGroupSection";
import { ClipPage } from "../../components/Clips/Clip.elements";

const UploadsPage = (props) => {
  return (
      <ClipPage data-testid="upload-completed-list">
        <PackageGroupSelection currentUser={props.currentUser} />
      </ClipPage>
  );
};

export default UploadsPage;
